var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 406.75 477.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #d3a56e;\n      }\n\n      .cls-2 {\n        fill: #1d1d1b;\n      }\n\n      .cls-3 {\n        fill: #fffffe;\n      }\n\n      .cls-4 {\n        fill: #deb886;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M244.4,337.73c2.42-1.84,3.99-4.74,3.99-8.02,0-5.57-4.51-10.08-10.08-10.08-.4,0-.8.03-1.19.08l-31.04-76.84-2.7-6.67-2.7,6.67-47.96,118.69c-.08,0-.15-.01-.23-.01-5.57,0-10.08,4.51-10.08,10.08,0,2.93,1.26,5.56,3.25,7.4l-14.76,36.52,4.17,3.02,15.02-37.17c.77.19,1.57.3,2.4.3,4.76,0,8.74-3.3,9.8-7.74h91.36l17.6,43.55,4.15-3.09-30.99-76.71ZM238.31,323.71c3.31,0,6,2.69,6,6s-2.69,6-6,6-6-2.69-6-6,2.69-6,6-6ZM152.5,377.63c-3.31,0-6-2.69-6-6s2.69-6,6-6,6,2.69,6,6-2.69,6-6,6ZM162.21,368.97c-.7-2.57-2.39-4.73-4.64-6.04l45.81-113.39,29.08,71.97c-2.56,1.83-4.23,4.81-4.23,8.2,0,5.57,4.51,10.08,10.08,10.08.51,0,1-.05,1.48-.12l11.84,29.3h-89.42Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "203.6 193.14 203.6 272.15 224.67 230.73 203.6 193.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "203.6 193.23 203.6 272.24 182.53 230.82 203.6 193.23"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 359.46,
    cy: 231.82,
    r: 5.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 305.06,
    cy: 349.95,
    r: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M231.9,179.55c7.53,14.51,22.68,24.43,40.16,24.43,24.98,0,45.22-20.25,45.22-45.22,0-11.48-4.29-21.96-11.34-29.93l-74.04,50.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M284.35,143.62c4.4,3.58,7.21,9.02,7.21,15.13,0,10.77-8.73,19.5-19.5,19.5-8.68,0-16.02-5.67-18.55-13.51l-11,7.53c5.13,11.19,16.43,18.97,29.55,18.97,17.95,0,32.5-14.55,32.5-32.5,0-8.82-3.52-16.81-9.22-22.67l-10.99,7.53Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 285.33,
    cy: 152.42,
    r: 5.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M369.69,88.27L406.75,0l-101.69,41.96-9.29,13.89-92.4-23.7-92.4,23.7-9.29-13.89L0,0l37.05,88.27,11.59,7.9-29.57,65.66v138.94l45.22,77.37,139.08,99.71,139.08-99.71,45.22-77.37v-138.94l-29.57-65.66,11.59-7.9ZM309.76,54.49l73.01-28.88-146.03,136.22,73.01-107.34ZM151.13,58.64l19.95,20.66c1.6-.91,3.45-1.44,5.43-1.44,6.08,0,11,4.92,11,11,0,2.11-.61,4.08-1.64,5.76l14.26,14.76v-62.1h7.63v62.44c.08.03.15.07.23.11l26.5-27.44c-.62-1.38-.98-2.91-.98-4.52,0-6.08,4.92-11,11-11,1.48,0,2.88.3,4.17.82l8.7-9.01,8.45,2.23-11.54,11.95c.77,1.5,1.21,3.2,1.21,5.01,0,6.08-4.92,11-11,11-1.67,0-3.25-.38-4.66-1.05l-26.41,27.34c.68,1.43,1.07,3.02,1.07,4.7,0,6.08-4.92,11-11,11s-11-4.92-11-11c0-2.1.6-4.05,1.61-5.72l-14.29-14.8c-1.05.33-2.17.51-3.32.51-6.08,0-11-4.92-11-11,0-1.29.23-2.53.64-3.68l-23.51-24.35,8.49-2.19ZM203.37,150.93l72.19-64.89-59.42,88.83-12.78,9.05-12.78-9.05-59.42-88.83,72.19,64.89ZM187.53,231.33l15.85-29.73,15.85,29.73-15.85,33.78-15.85-33.78ZM219.22,347.39h-31.7l15.85-34.87,15.85,34.87ZM173.72,225.81l-41.27,16.42,38.93-62.43,21.52,14.66-19.18,31.35ZM213.85,194.47l21.52-14.66,38.93,62.43-41.27-16.42-19.18-31.35ZM23.97,25.61l73.01,28.88,73.01,107.34L23.97,25.61ZM32.69,166.19l28.15-61.7,6.82,4.65-27.3,61.18,21.62,43.24-29.29-22.51v-24.85ZM90.52,349.95c0-4.49,2.65-8.35,6.47-10.12v-51.01l-45.38-46.69c-1.33.56-2.79.87-4.32.87-6.17,0-11.17-5-11.17-11.17s5-11.17,11.17-11.17,11.17,5,11.17,11.17c0,1.21-.2,2.37-.55,3.46l48.39,50.54v53.96c3.87,1.76,6.56,5.64,6.56,10.17,0,6.17-5,11.17-11.17,11.17s-11.17-5-11.17-11.17ZM119.91,401.16l-21.97-15.89,21.97-16.79v32.68ZM84.1,230.54l-28.48-61.33,23.67-52.16,90.99,62-20.94,19.04-28.33,45.22-36.9-12.78ZM123.61,260.9l51.9-21.55-19.66,48.61-22.9-19.22v-.66l-9.34-7.17h0ZM132.95,285.87l17.96,14.3-17.96,44.4v-58.7ZM203.37,461.51l-46.63-33.72,13.26-30.82h66.74l13.26,30.82-46.63,33.72ZM273.21,411.01l-13.29,9.61-14.5-35.09h-84.1l-14.5,35.09-13.29-9.61v-35.29l49.57-122.61,16.4,34.39-27.82,70.79h63.39l-27.82-70.79,16.4-34.39,49.57,122.61v35.29ZM273.8,344.57l-17.96-44.4,17.96-14.3v58.7ZM283.13,260.91l-9.34,7.17v.66l-22.9,19.22-19.66-48.61,51.9,21.55h0ZM257.41,198.09l-20.94-19.04,90.99-62,23.67,52.16-28.48,61.33-36.9,12.78-28.33-45.22ZM286.83,401.16v-32.68l21.97,16.79-21.97,15.89ZM359.46,242.99c-1.53,0-2.99-.31-4.32-.87l-45.38,46.69v51.01c3.82,1.78,6.47,5.63,6.47,10.12,0,6.17-5,11.17-11.17,11.17s-11.17-5-11.17-11.17c0-4.52,2.7-8.41,6.56-10.17v-53.96l48.39-50.54c-.35-1.09-.55-2.25-.55-3.46,0-6.17,5-11.17,11.17-11.17s11.17,5,11.17,11.17-5,11.17-11.17,11.17ZM374.05,166.19v24.85l-29.29,22.51,21.62-43.24-27.3-61.18,6.82-4.65,28.15,61.7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "326.61 372.45 326.61 301.08 374.01 255 374.01 265.66 336.42 303.25 336.42 364.83 326.61 372.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M365.05,310.7c-6.64-1.17-12.97,3.25-14.14,9.89-.59,3.32.23,6.56,2.02,9.12l12.13-19.01Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 47.28,
    cy: 231.82,
    r: 5.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 101.69,
    cy: 349.95,
    r: 5.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "80.14 372.45 80.14 301.08 32.73 255 32.73 265.66 70.33 303.25 70.33 364.83 80.14 372.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M174.84,179.55c-7.53,14.51-22.68,24.43-40.16,24.43-24.98,0-45.22-20.25-45.22-45.22,0-11.48,4.29-21.96,11.34-29.93l74.04,50.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M122.4,143.62c-4.4,3.58-7.21,9.02-7.21,15.13,0,10.77,8.73,19.5,19.5,19.5,8.68,0,16.02-5.67,18.55-13.51l11,7.53c-5.13,11.19-16.43,18.97-29.55,18.97-17.95,0-32.5-14.55-32.5-32.5,0-8.82,3.52-16.81,9.22-22.67l10.99,7.53Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 121.42,
    cy: 152.42,
    r: 5.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 244.51,
    cy: 77.86,
    r: 5.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 203.51,
    cy: 119.86,
    r: 5.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 176.51,
    cy: 88.86,
    r: 5.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.fbb82e100efbe609776b2ac94d4c5dab.svg";
export { ForwardRef as ReactComponent };